import React from 'react';
import { ProgressContainer, ProgressFlex, StepWrapper, StepCircle, StepLabel, ProgressLine } from './Styles';

export default function StepProgress({ currentStep }) {
    const steps = [
        { number: 1, label: 'Personal' },
        { number: 2, label: 'Institution' },
        { number: 3, label: 'Guardian' },
    ];

    return (
        <ProgressContainer>
            <ProgressFlex>
                <StepWrapper>
                    {steps.map((step, index) => (
                        <React.Fragment key={step.number}>
                            <div className="flex flex-col items-center">
                                <StepCircle $step={step.number} $currentStep={currentStep}>
                                    {currentStep > step.number ? '✓' : step.number}
                                </StepCircle>
                                <StepLabel $step={step.number} $currentStep={currentStep}>
                                    {step.label}
                                </StepLabel>
                            </div>
                            {index < steps.length - 1 && (
                                <ProgressLine $step={step.number} $currentStep={currentStep} />
                            )}
                        </React.Fragment>
                    ))}
                </StepWrapper>
            </ProgressFlex>
        </ProgressContainer>
    );
}